import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'

const PrivateMessageIcon = () => {
  return (
    <Box >
    <Avatar sx={{width:'70px', height:'70px'}}>
    </Avatar>
    </Box>
  )
}

export default PrivateMessageIcon
